import { currentSubdomain } from './identity';

// Segments that would otherwise mint a span name per entity.
const ID_SEGMENT = /^\d+$|^[0-9a-fA-F]{8}-[0-9a-fA-F-]{27,}$|^[0-9a-fA-F]{16,}$/;

// The tenant appears dotted in URLs ('emil-test.sysarb.dev') and underscored in
// rids ('emil-test_sysarb_dev'), so both spellings are substituted.
const tenantTokens = (): string[] => {
    const subdomain = currentSubdomain();
    if (subdomain == null || subdomain === '') return [];
    return [subdomain, subdomain.replaceAll('.', '_')];
};

const templateSegment = (segment: string, tenants: string[]): string => {
    if (tenants.includes(segment)) return '{tenant}';
    if (ID_SEGMENT.test(segment)) return '{id}';
    return segment;
};

/** 'v1.emil-test_sysarb_dev.api-keys' -> 'v1.{tenant}.api-keys' */
export const templateRid = (rid: string): string => {
    const tenants = tenantTokens();
    return rid.split('.').map(segment => templateSegment(segment, tenants)).join('.');
};

/**
 * 'POST https://host/api/v1/emil-test.sysarb.dev/x?token=…' -> 'POST /api/v1/{tenant}/x'.
 * Only the path is used: a query string is both unbounded and the most likely place
 * for something sensitive to end up, and neither belongs in a span name.
 */
export const templateHttpSpanName = (method: string, url: string): string => {
    let path: string;

    try {
        path = new URL(url, window.location.origin).pathname;
    } catch {
        return method;
    }

    const tenants = tenantTokens();
    const templated = path
        .split('/')
        .map(segment => (segment === '' ? segment : templateSegment(segment, tenants)))
        .join('/');

    return `${method} ${templated}`;
};
